module.exports = __webpack_public_path__ + "static/media/tarjeta-eroski-cupon-cropped.80ca5734.png";